"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tierIncludesLabel = exports.BILLING_INTERVAL_FIELD_LABEL = exports.BASIC_PLAN_LABEL = void 0;
exports.formatSubscriptionPlanLabel = formatSubscriptionPlanLabel;
exports.formatBillingLineLabel = formatBillingLineLabel;
exports.tiersIncludedIn = tiersIncludedIn;
exports.formatTierLabel = formatTierLabel;
exports.formatBillingIntervalDisplay = formatBillingIntervalDisplay;
exports.userHasProBase = userHasProBase;
exports.normalizeBillingTierId = normalizeBillingTierId;
/** Εμφανιζόμενο όνομα βασικού πακέτου (API plan παραμένει `PRO`). */
exports.BASIC_PLAN_LABEL = 'Basic';
function formatSubscriptionPlanLabel(plan) {
    return plan === 'PRO' ? exports.BASIC_PLAN_LABEL : 'FREE';
}
/** Αντικαθιστά «PRO» σε κείμενα/labels billing (π.χ. γραμμές quote από API). */
function formatBillingLineLabel(label) {
    return label.replace(/\bPRO\b/g, exports.BASIC_PLAN_LABEL);
}
const TIER_ORDER = ['pro', 'business'];
function tiersIncludedIn(tier) {
    const idx = TIER_ORDER.indexOf(tier);
    if (idx < 0)
        return [];
    return TIER_ORDER.slice(0, idx + 1);
}
function formatTierLabel(tier) {
    return tier === 'pro' ? 'Pro' : 'Business';
}
/** Τίτλος πεδίου στην «Τρέχουσα κατάσταση». */
exports.BILLING_INTERVAL_FIELD_LABEL = 'Διάστημα χρέωσης';
/**
 * Μηνιαία / ετήσια πληρωμή συνδρομής.
 * Όχι ημερομηνία λήξης — αυτή είναι στο «Ενεργό έως».
 */
function formatBillingIntervalDisplay(interval, options) {
    if (interval === 'MONTHLY')
        return 'Μηνιαία πληρωμή';
    if (interval === 'ANNUAL')
        return 'Ετήσια πληρωμή';
    if (options === null || options === void 0 ? void 0 : options.proTrialActive)
        return 'Δοκιμή (χωρίς χρέωση)';
    if ((options === null || options === void 0 ? void 0 : options.plan) === 'FREE' && !(options === null || options === void 0 ? void 0 : options.hasPaidPackage))
        return '—';
    return 'Δεν έχει οριστεί';
}
function userHasProBase(plan, activeSlugs) {
    if (plan !== 'PRO')
        return false;
    for (const slug of activeSlugs) {
        if (slug === 'basic' || slug === 'pro' || slug === 'business')
            return true;
        // legacy
        if (slug === 'bronze' || slug === 'silver' || slug === 'gold')
            return true;
    }
    return false;
}
exports.tierIncludesLabel = {
    pro: 'Περιλαμβάνει Basic',
    business: 'Περιλαμβάνει Pro και Basic',
};
function normalizeBillingTierId(tier) {
    if (!tier)
        return null;
    const lower = tier.toLowerCase();
    if (lower === 'pro' || lower === 'bronze' || lower === 'silver')
        return 'pro';
    if (lower === 'business' || lower === 'gold')
        return 'business';
    return null;
}
